/*
 * Generic access-filter injection points, in the registerNavChild tradition:
 * the host consults these registries but ships no behavior of its own. A
 * plugin (e.g. nondev/page-access) may register additional access checks for
 * routes and navigation entries. With nothing registered - or if the plugin
 * that registered them is removed - every check passes and access control is
 * exactly the host's built-in permission gating.
 *
 * Guard contract: fn(target, permissions) => boolean. Only an explicit
 * `false` denies; anything else (including a thrown error) allows, so a
 * misbehaving guard can never lock users out of the portal.
 */

let routeGuards = [];
let navFilters  = [];

export function registerRouteAccessGuard(fn) {
	if (typeof fn === 'function') routeGuards.push(fn);
}

export function registerNavAccessFilter(fn) {
	if (typeof fn === 'function') navFilters.push(fn);
}

function allowedBy(guards, target, permissions) {
	for (let i = 0; i < guards.length; i++) {
		try {
			if (guards[i](target, permissions) === false) return false;
		} catch (err) {
			console.error('[accessGuards] guard threw; failing open', err);
		}
	}
	return true;
}

// target: { path, ...route extras } (private, permissions, title)
export function routeAllowed(target, permissions) {
	return allowedBy(routeGuards, target, permissions);
}

// target: a navigation row or child ({ title, url?, permissions, ... })
export function navEntryAllowed(target, permissions) {
	return allowedBy(navFilters, target, permissions);
}
